import styled from "styled-components";

export const StyledChatMenuContainer = styled.div.attrs({ className: "ChatMenuContainer" })<{ variant?: string }>`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  width: 250px;
`;

export const StyledChatMenuItem = styled.div.attrs({ className: "ChatMenuItem" })<{ variant?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }

  .left-icon {
    margin-right: 8px;
  }

  .right-icon {
    margin-left: auto;
  }

  .description {
    font-size: 12px;
    color: #6c6c6c;
  }
`;

export const StyledChatMenuDivider = styled.div.attrs({ className: "ChatMenuSubDivider" })<{ variant?: string }>`
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
`;

export const StyledChatMenuSubtitle = styled.div.attrs({ className: "ChatMenuSubTitle" })<{ variant?: string }>`
  padding: 8px 16px;
  font-weight: bold;
  color: #333333;
`;
